module.exports = __webpack_public_path__ + "static/bg3-d7d31afd7360eed7d9a946815b44d3f6.svg";